import { formatUnits } from "viem";

import type { GasFundsStatus } from "../../virtual-machines/ethereum/types";

export function getGasFundsStatus(
  value: bigint | null | undefined,
  decimals: null | number | undefined,
  gasBuffer = 0.001,
): GasFundsStatus | null {
  if (value == null || decimals == null) return null;

  const numeric = parseFloat(formatUnits(value, Number(decimals)));
  return numeric >= gasBuffer ? "enough" : "not_enough";
}
